import { useContext } from 'react';

import { WindowManagerContext } from '../contexts/WindowManagerContext';

export const useWindowManagerContext = () => useContext(WindowManagerContext);
